export const COLORS = {
  text: {
    light: '#1D1F21',
    dark: '#c9cacc',
  },
  background: {
    light: '#F4E2BE',
    dark: '#1D1F21',
  },
  primary: {
    light: '#7B4B36',
    dark: '#2bbc8a',
  },
  secondary: {
    light: '#D2C3A5',
    dark: '#393939',
  },
  tertiary: {
    light: '#8a836a',
    dark: '#757575',
  },
};

export const COLOR_MODE_KEY = 'color-mode';
export const INITIAL_COLOR_MODE_CSS_PROP = '--initial-color-mode';
